import apiClient from './api';
import type {
  CreateStockAuditRequest,
  ScanOutcome,
  StockAudit,
  StockAuditDetails,
} from '../types/stockAudit';

export const stockAuditService = {
  // Audit history of a company, newest first
  list: async (companyId: number): Promise<StockAudit[]> => {
    const response = await apiClient.get<StockAudit[]>('/stock-audits', {
      params: { companyId },
    });
    return response.data;
  },

  getDetails: async (auditId: number): Promise<StockAuditDetails> => {
    const response = await apiClient.get<StockAuditDetails>(`/stock-audits/${auditId}`);
    return response.data;
  },

  create: async (request: CreateStockAuditRequest): Promise<StockAudit> => {
    const response = await apiClient.post<StockAudit>('/stock-audits', request);
    return response.data;
  },

  scan: async (auditId: number, serialNumber: string): Promise<ScanOutcome> => {
    const response = await apiClient.post<ScanOutcome>(`/stock-audits/${auditId}/scans`, {
      serialNumber,
    });
    return response.data;
  },

  removeScan: async (auditId: number, scanId: number): Promise<void> => {
    await apiClient.delete(`/stock-audits/${auditId}/scans/${scanId}`);
  },

  // Closes the audit for good: freezes the missing list
  complete: async (auditId: number): Promise<StockAuditDetails> => {
    const response = await apiClient.post<StockAuditDetails>(`/stock-audits/${auditId}/complete`);
    return response.data;
  },

  // Discards an open audit
  cancel: async (auditId: number): Promise<void> => {
    await apiClient.delete(`/stock-audits/${auditId}`);
  },
};
